import React from 'react'

import logo from './images/gartner_logo_white_comp.png'
import './css/Header.css'

export default (props) => {
  const renderTitle = () => {
    if(props.title === 'Game' || props.title === 'Scores'){
      return <h1 className="GameTitle">Hype Cycle for Emerging Technologies</h1>
    }
  }
  return(
    <header className={`header ${props.title}-header`}>
      <a className="logo" onClick={() => props.changeScreen('Welcome')}>
        <img src={logo} alt="" />
      </a>
      { renderTitle() }
      <div>
        <a onClick={() => props.changeScreen('Scores')}>Scores</a>
        <a onClick={() => props.changeScreen('Game')}>Game</a>
      </div>
    </header>
  )
}



/** WEBPACK FOOTER **
 ** ./src/Header.js
 **/